import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  AvailableCompaniesResponse,
  Breadcrumb,
  CompaniesResponseModel,
} from '@models';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  private company = environment.COMPANIES;

  public breadcrumb: Subject<Breadcrumb[]> = new Subject<Breadcrumb[]>();
  public statusCompanyList: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly http: HttpClient) {}

  public setBreadcrumb(bread: Breadcrumb[]): void {
    this.breadcrumb.next(bread);
  }

  public companyList(status: boolean): void {
    this.statusCompanyList.next(status);
  }

  /**
   * Get companies
   * @param params filters
   */
  public getCompanies(filters?: any): Observable<CompaniesResponseModel> {
    const rute = `${this.company.COMPANY}${filters || ''}`;
    return this.http.get<CompaniesResponseModel>(rute);
  }

  /**
   * Get avaiable companies (Companies unassigned and not archived)
   * @param project project id
   * @param typeProject type project id
   */
  public getAvailableCompanies(
    project: string,
    typeProject: string
  ): Observable<AvailableCompaniesResponse> {
    return this.http.get<AvailableCompaniesResponse>(this.company.AVAILABLE, {
      params: {
        project,
        typeProject,
      },
    });
  }
}
